// features/clients/clientService.js
import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

const getClients = async () => {
  const response = await axios.get(`${base_url}client`);
  return response.data;
};

const getClient = async (id) => {
  const response = await axios.get(`${base_url}client/${id}`);
  return response.data;
};

export const clientService = {
  getClients,
  getClient,
};
